import {SupplementModelV1} from 'resources/GeneratedModels/Supplement/SupplementModel.v1';
import {validators} from './supplement.validators';
import {extensions} from './supplement.extensions';

SupplementModelV1.extend(extensions);
SupplementModelV1.addValidators(validators);

export {SupplementModelV1};
